/**
* This file was auto-generated by the FrontendConstantsGenerator.
* Do not make direct changes to the file.
*/

export enum DOPE_TABLE_COLUMN_CATEGORIES {
  PROJECT_CHARACTERISTICS = 'project_characteristics',
  ANNOTATIONS = 'annotations',
  PARTICIPANT_CHARACTERISTICS = 'participant_characteristics',
  HUB_CHARACTERISTICS = 'hub_characteristics',
  SCREENER_QUESTIONS = 'screener_questions',
  DEMOGRAPHIC_CHARACTERISTICS = 'demographic_characteristics',
  PROFESSIONAL_CHARACTERISTICS = 'professional_characteristics',
  TECHNICAL_CHARACTERISTICS = 'technical_characteristics',
  PRODUCTS_AND_SERVICES = 'products_and_services',
  DISCUSSION_TOPICS = 'discussion_topics'
}

export enum DOPE_TABLES {
  WORKSPACE_ALL = 'workspace_all',
 WORKSPACE_APPLIED = 'workspace_applied',
 WORKSPACE_APPROVED = 'workspace_approved',
 WORKSPACE_COMPLETED = 'workspace_completed',
 WORKSPACE_INVITED = 'workspace_invited',
 WORKSPACE_POTENTIAL = 'workspace_potential',
 WORKSPACE_REMOVED_FROM_STUDY = 'workspace_removed_from_study',
 WORKSPACE_SCHEDULED = 'workspace_scheduled',
 WORKSPACE_STARTED = 'workspace_started',
 WORKSPACE_SUBMITTED = 'workspace_submitted',
 WORKSPACE_EXPORT = 'workspace_export',
 WORKSPACE_DATA_GRID = 'workspace_data_grid',
 WORKSPACE_DATA_GRID_EXPORT = 'workspace_data_grid_export',
 PARTICIPANT_POPULATION_EXPORT = 'participant_population_export'
}

export const DOPE_TABLE_EXPORT_TABLE_NAMES = {
  WORKSPACE_EXPORT: 'workspace_export',
  WORKSPACE_DATA_GRID_EXPORT: 'workspace_data_grid_export',
  PARTICIPANT_POPULATION_EXPORT: 'participant_population_export'
} as const;

export const COLUMN_LIMIT = 20;
